import React, { forwardRef, ChangeEvent, FocusEventHandler, KeyboardEvent, ReactNode } from 'react';
import { v4 as uuid } from 'uuid';
import { css, SerializedStyles } from '@emotion/react';
import { InputWrapper, InputLabel, InnerLabel } from './style';
export interface InputProps {
  type: 'checkbox' | 'radio' | 'text' | 'date' | 'password';
  name?: string;
  className?: string;
  value?: string | null;
  placeholder?: string;
  styles?: SerializedStyles;
  rangeType?: 'from' | 'to';
  children?: ReactNode;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  onKeyPress?: (event: KeyboardEvent) => void;
  onKeyDown?: (event: KeyboardEvent) => void;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  required?: boolean;
  disabled?: boolean;
  props?: any;
}
export interface CheckBoxProps {
  styles?: SerializedStyles;
}

const Input = forwardRef(function Input(
  {
    type = 'text',
    className = '',
    name = '',
    value = '',
    placeholder = '',
    styles = css``,
    rangeType,
    children,
    checked,
    onChange = (e: ChangeEvent) => {
      return;
    },
    onKeyPress = (e: KeyboardEvent) => {
      return;
    },
    onKeyDown = (e: KeyboardEvent) => {
      return;
    },
    onBlur = (e: any) => {
      return;
    },
    onFocus = (e: any) => {
      return;
    },
    required = false,
    disabled = false,
    props,
  }: InputProps,
  ref,
) {
  const domId = uuid();
  return (
    <InputWrapper
      data-disable={disabled}
      data-type={type}
      data-name={name || placeholder}
      styles={styles}
      className={className}
    >
      <InputLabel data-type={type}>
        <input
          type={type}
          name={name}
          value={value || ''}
          placeholder={placeholder}
          data-placeholder={placeholder || ''}
          data-disabled={disabled}
          data-range={rangeType}
          id={domId}
          onChange={onChange}
          onFocus={onFocus}
          onKeyPress={onKeyPress}
          onKeyDown={onKeyDown}
          checked={checked}
          onBlur={onBlur}
          required={required}
          disabled={disabled}
          ref={ref}
          {...props}
        />
        <label htmlFor={domId} data-type={type}>
          {placeholder}
        </label>
        {required && <div className={'validate-txt'} data-type={'validate'} />}
      </InputLabel>
      <InnerLabel className={'inner-label'} htmlFor={domId}>
        {children}
      </InnerLabel>
    </InputWrapper>
  );
});

export default Input;
